var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"value-sample"},[_c('div',{staticClass:"count"},[_vm._v("現在のカウント: "+_vm._s(_vm.count))]),_c('button',{on:{"click":_vm.decrement}},[_vm._v("減らす")]),_c('button',{on:{"click":_vm.increment}},[_vm._v("増やす")])])}
var staticRenderFns = []

export { render, staticRenderFns }